import { useCallback } from 'react'
import { useVerticalModule } from '@lipaflow/shared'

/**
 * Where a link to a shared page should go for this vertical: its own page
 * when it does that job itself, nowhere (null) when it has retired the page
 * from its menu, else the shared page.
 */
export function useSharedPage() {
  const module = useVerticalModule()
  return useCallback((href: string): string | null => {
    const own = module?.sharedPageFor?.[href]
    if (own) return own
    return module?.hiddenSharedNav?.includes(href) ? null : href
  }, [module])
}
